/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Company_Registration_Services_LabelInputs */

const en_company_registration_services_label = /** @type {(inputs: Company_Registration_Services_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Products / Services`)
};

const de_company_registration_services_label = /** @type {(inputs: Company_Registration_Services_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Produkte / Leistungen`)
};

/**
* | output |
* | --- |
* | "Products / Services" |
*
* @param {Company_Registration_Services_LabelInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const company_registration_services_label = /** @type {((inputs?: Company_Registration_Services_LabelInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Company_Registration_Services_LabelInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_company_registration_services_label(inputs)
	return en_company_registration_services_label(inputs)
});